import {defineStore} from "pinia";
import {ref} from "vue";
import {isSetUserTk} from "@/router/index"


// const to404 = () => {
//     alert('404')
// }
const checkUserTk = (value: any) => {
    return !!(value && value.length === 16);
}

export const useUserStore = defineStore('user', () => {

    const userTk = ref<string>('')

    const pType = ref<string>('')


    const getUserTk = () => {
        if (checkUserTk(userTk.value)) return userTk.value
        const localUserTk = localStorage.getItem('tk')
        if (checkUserTk(localUserTk)) return localUserTk
        // to404()
    }

    const getPType = () => {
        if (pType.value === '0' || pType.value === '1') return pType.value
        const localPType = localStorage.getItem('pt')
        if (localPType === '0' || localPType === '1') return localPType
        // to404()
    }

    /**
     * 只在/index,和/goods_details 才设置
     */
    const setUserInfo = (route: any) => {
        let routeUserTk = ''
        if (route.name === 'Index' || route.name === 'KdIndex' || route.name === 'ShopPoster') {
            routeUserTk = route.params.tk
        } else if (route.name === 'GoodsDetails') {
            routeUserTk = route.query.userid
        } else {
            return false
        }
        if (checkUserTk(routeUserTk)) {
            userTk.value = routeUserTk
            localStorage.setItem('tk', routeUserTk as string);
            return true
        }
        return false
    }

    return {setUserInfo, getUserTk, getPType}
})




